import { connect } from "react-redux";
import SiteInspectionChecklistSiteList from "./site-inspection-checklist-site-list";
// Import the actions for deleting and emailing - these will be implemented later
// import { onRemove, onEmail } from "../../actions";

const mapStateToProps = ({ profile }) => ({
    role: profile.role,
});

const mapDispatchToProps = {
    // Placeholder functions for now - will be implemented with real API later
    onDelete: (id) => console.log("Delete site inspection checklist:", id),
    onEmail: (id) => console.log("Email site inspection checklist:", id),
};

export default connect(mapStateToProps, mapDispatchToProps)(SiteInspectionChecklistSiteList); 